import {mapGetters, mapMutations, mapActions} from 'vuex'
import {gotoAdobeService} from "@/utils/adobe";

export default {
  name: 'unsupported',
  //---components
  //---data
  data () {
    return {}
  },
  //---hooks
  created: function () {
    if (!this.report) {
      this.$router.push({name: 'searchProperty'});
    }
  },
  computed: {
    ...mapGetters({
      URLParams: 'APP/URLParams',
      content: 'APP/content',
      analysis: 'ANALYSIS/analysis',
      report: 'REPORT/report',
      client: 'CLIENT/client',
    }),
  },
  //---methods
  methods: {
    getAppeal() {
      window.open(process.env.VUE_APP_APPEAL_NOW_URL + this.analysis.discountCode)
    },
    gotoSearch() {
      this.$router.push({name: 'searchProperty'});
    },
    startAppeal() {
      gotoAdobeService();
    }
  }
}
